export function normalizePartnerNetworkCode(value: string): string {
  return value.replace(/\s/g, '').toUpperCase().replace(/[^A-Z0-9]/g, '');
}

export function formatPartnerNetworkCode(code: string | null | undefined): string {
  if (code == null || code === '') return '';
  return normalizePartnerNetworkCode(code);
}

export const PARTNER_NETWORK_CODE_PATTERN = /^[A-Z0-9]+$/;
